module.exports = __webpack_public_path__ + "static/media/MEJPEROL_MENU-normal.e07cb3f4.png";